import {
  IconGauge,
  IconMenu2, IconMenuDeep,
  IconHome,
  IconWallet,
  IconReport,
  IconHelp, IconLogout,
  IconUsers
} from '@tabler/icons-react';
import { Group, ScrollArea, Button } from '@mantine/core';
// import { LinksGroup } from '../NavbarLinksGroup/NavbarLinksGroup';
// import { UserButton } from '../UserButton/UserButton';
// import Logo from '../Assets/Defaultlogo.png';
import './Sidenavbar.css';
import { Menu } from 'antd';
import { useState } from 'react';
import Disthome from '../Components/Distributor/Home';
import Dashboarddist from '../Components/Distributor/Dashboard';
import Topinrequestdist from '../Components/Distributor/Balance/Topinrequest';
import Fundtodisttransfer from '../Components/Distributor/Balance/Fundtodisttransfer';
import Distledger from '../Components/Distributor/Reports/Distledger';
import Disttrxnreports from '../Components/Distributor/Reports/Distrxnreports';
import Disttrxnsummary from '../Components/Distributor/Reports/Disttrxnsummary';
import Distributorcommandtds from '../Components/Distributor/Reports/Distcommandtds';
import Fundtransfermapped from '../Components/Distributor/Balance/Fundtransfermapped';
import Mappedusers from '../Components/Distributor/CRM/Mappedusers';

const mockdata = [
  {
    key: "1",
    label: "Home",
    icon: <IconHome size={18} />,
  },

  {
    key: "2",
    label: "Dashboard",
    icon: <IconGauge size={18} />,
  },
  {
    key: "3",
    label: "Balance",
    icon: <IconWallet size={18} />,
    children: [
      {
        key: "3-main",
        label: "Top In Requests",
      },
      {
        key: "3-1",
        label: "Wallet to Wallet Transfer",
      },
      {
        key: "3-2",
        label: "Fund Transfer (M)",
      },
      // {
      //   key: "3-3",
      //   label: "Revert Transfer (M)",
      // },
    ],
  },
  {
    key: "6",
    label: "Mapped users",
    icon: <IconUsers size={18} />,
    children: [
      {
        key: "6-main",
        label: "Users",
      },
      // {
      //   key: "3-1",
      //   label: "Wallet to Wallet Transfer",
      // },
      // {
      //   key: "3-2",
      //   label: "Fund Transfer (M)",
      // },
      // {
      //   key: "3-3",
      //   label: "Revert Transfer (M)",
      // },
    ],
  },
  {
    key: "4",
    label: "Reports",
    icon: <IconReport size={18} />,
    children: [
      {
        key: "4-main",
        label: "Ledger Reports",
      },
      {
        key: "4-1",
        label: "Transaction Reports",
      },
      {
        key: "4-2",
        label: "Transaction Summary Reports",
      },
      {
        key: "4-3",
        label: "Commission & TDS Reports",
      },
      {
        key: "4-4",
        label: "Fees & Charges Reports",
      },
    ],
  },
  {
    key: "5",
    label: "Support",
    icon: <IconHelp size={18} />,
  },
];

export function NavbarNesteddist() {
  // const links = mockdata.map((item) => <LinksGroup {...item} key={item.label} />);
  const [selectedKey, setSelectedKey] = useState("1"); // Default selected key
  const [collapsed, setCollapsed] = useState(false);

  const renderSelectedItem = (key) => {
    switch (key) {
      case "1":
        return <Disthome Headername={'Home'} />;
      // return ((Loggeddetails?.User_ID?.isAdminLoggedIn === true && Isadminsession === "true") ? <Dashboard Headername={"Dashboard"} />
      //     : <Alert message={`${loadingverificationstate ? "Loading..." : "Unauthorized: Without OTP Not Valid"}`} type='error' showIcon style={{ margin: '5px' }} />)
      case "2":
        return <Dashboarddist Headername={'Dashboard'} />;
      // case "3":
      //   return <Topinrequest Headername={'Top In Requests'}/>;
      case "3-main":
        return <Topinrequestdist Headername={'Top In Requests'} />;
      case "3-1":
        return <Fundtodisttransfer Headername={'Wallet to Wallet Transfer'} />;
      case "3-2":
        return <Fundtransfermapped Headername={'Fund Transfer Mapped'} />;
      // case "3-3":
      //   return <Fundtodisttransfer Headername={'Fund to Distributor Transfer'} />;
      // case "4":
      //   return;
      case "4-main":
        return <Distledger Headername={'Distributor Ledger'} />;
      case "4-1":
        return <Disttrxnreports Headername={'Distributor Transaction Reports'} />;
      case "4-2":
        return <Disttrxnsummary Headername={'Distributor Transaction Summary'} />;
      case "4-3":
        return <Distributorcommandtds Headername={'Distributor Commission and TDS'} />;
      case "4-4": // fees and charges
        return;
        case "6-main":
          return <Mappedusers Headername={'Users'} />;

      //     return ((Loggeddetails?.User_ID?.isAdminLoggedIn === true && Isadminsession === "true") ? <Buyerlists Headername={"Buyer List"} />
      //         : <Alert message={`${loadingverificationstate ? "Loading..." : "Unauthorized: Without OTP Not Valid"}`} type='error' showIcon style={{ margin: '5px' }} />)
      // case "sm-1":
      //     return ((Loggeddetails?.User_ID?.isAdminLoggedIn === true && Isadminsession === "true") ? <Invoicehistory Headername={"Invoice History"} />
      //         : <Alert message={`${loadingverificationstate ? "Loading..." : "Unauthorized: Without OTP Not Valid"}`} type='error' showIcon style={{ margin: '5px' }} />)
      // case "3-main":
      //     return ((Loggeddetails?.User_ID?.isAdminLoggedIn === true && Isadminsession === "true") ? <Storelisting Headername={"Store Listing"} />
      //         : <Alert message={`${loadingverificationstate ? "Loading..." : "Unauthorized: Without OTP Not Valid"}`} type='error' showIcon style={{ margin: '5px' }} />)
      // case "sm-2":
      //     return ((Loggeddetails?.User_ID?.isAdminLoggedIn === true && Isadminsession === "true") ? <Inventorymangement Headername={"Inventory Mangement"} />
      //         : <Alert message={`${loadingverificationstate ? "Loading..." : "Unauthorized: Without OTP Not Valid"}`} type='error' showIcon style={{ margin: '5px' }} />)
      // case "4":
      //     return ((Loggeddetails?.User_ID?.isAdminLoggedIn === true && Isadminsession === "true") ? <Publicinvlink Headername={"Public Invoice Link"} />
      //         : <Alert message={`${loadingverificationstate ? "Loading..." : "Unauthorized: Without OTP Not Valid"}`} type='error' showIcon style={{ margin: '5px' }} />)
      // case "5":
      //     return ((Loggeddetails?.User_ID?.isAdminLoggedIn === true && Isadminsession === "true") ? <Refferalsupport Headername={"Refer Others"} />
      //         : <Alert message={`${loadingverificationstate ? "Loading..." : "Unauthorized: Without OTP Not Valid"}`} type='error' showIcon style={{ margin: '5px' }} />)
      // case "6":
      //     return ((Loggeddetails?.User_ID?.isAdminLoggedIn === true && Isadminsession === "true") ? <Digicontact Headername={"Contact Us"} Notshowheader={true} />
      //         : <Alert message={`${loadingverificationstate ? "Loading..." : "Unauthorized: Without OTP Not Valid"}`} type='error' showIcon style={{ margin: '5px' }} />)
      // case "7":
      //     return ((Loggeddetails?.User_ID?.isAdminLoggedIn === true && Isadminsession === "true") ? <Websitebuildrform Headername={"Website Builder Form"} />
      //         : <Alert message={`${loadingverificationstate ? "Loading..." : "Unauthorized: Without OTP Not Valid"}`} type='error' showIcon style={{ margin: '5px' }} />)
      // case "8":
      //     return ((Loggeddetails?.User_ID?.isAdminLoggedIn === true && Isadminsession === "true") ? <Caservices Headername={"Acccounting Services"} />
      //         : <Alert message={`${loadingverificationstate ? "Loading..." : "Unauthorized: Without OTP Not Valid"}`} type='error' showIcon style={{ margin: '5px' }} />)
      default:
        return <div>Select an option</div>;
    }
  }

  return (
    <div style={{ display: 'flex', minHeight: '100vh' }}>
      <nav className={"navbar"} style={{
        width: collapsed ? 80 : 260,
        transition: "all .3s ease",
        overflow: "hidden",
      }}>
        <div className={"header"}>
          <Group justify="space-between">
            {/* <Image
              src={Logo}
              alt="LOGO"
              preview={false}
              height={collapsed ? 35 : 50}
            /> */}

            {collapsed ? (
              <IconMenu2
                size={24}
                style={{ cursor: "pointer" }}
                onClick={() => setCollapsed(false)}
              />
            ) : (
              <IconMenuDeep
                size={24}
                style={{ cursor: "pointer" }}
                onClick={() => setCollapsed(true)}
              />
            )}
          </Group>
        </div>

        <ScrollArea className={"links"}>
          <div className={"linksInner"} style={{ overflow: "hidden", }}>
            <Menu
              defaultSelectedKeys={['1']}
              defaultOpenKeys={['sub1']}
              mode="inline"
              inlineCollapsed={collapsed}
              items={mockdata}
              onSelect={(e) => setSelectedKey(e.key)} // Update selected key
            />
          </div>
        </ScrollArea>


        <div className={"footer"}>
          <Button size='xs' color='red' variant='light' fullWidth radius={0} rightSection={collapsed ? <IconLogout size={20} /> : <>Logout <IconLogout size={20} style={{ marginLeft: '5px' }} /> </>}></Button>
        </div>
      </nav>
      <div
        style={{
          flex: 1,
          // marginLeft: collapsed ? 80 : 260,
          transition: "all .3s ease",
          // padding: 5,
        }}
      >
        {renderSelectedItem(selectedKey)}
      </div>
    </div>
  );
}